import {Component, OnInit, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import {Annotation} from 'src/app/models/annotatios';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-annotation-dialog',
  templateUrl: './member-annotation-dialog.component.html',
  styleUrls: [ './member-annotation-dialog.component.scss' ]
})
export class MemberAnnotationDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public annotationForm: FormGroup;
  public statusList: any[] = []
  public isEdit: boolean

  constructor (
    private fb: FormBuilder,
    public matDialogRef: MatDialogRef<MemberAnnotationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Annotation
  ) {

    if (this.data.id == '0') {
      this.isEdit = false
    } else {
      this.isEdit = true
    }
    this.statusList.push({name: "None", value: 0})
    this.statusList.push({name: "Pendente", value: 1})
    this.statusList.push({name: "Finalizado", value: 2})

    this.annotationForm = this.createAnnotationForm(this.data)
  }

  ngOnInit () {

  }

  createAnnotationForm (data) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      text: new FormControl(data.text, [ Validators.required ]),
      date: new FormControl(data.date, [ Validators.required ]),
      status: new FormControl(data.status, [ Validators.required ]),
      member_id: new FormControl(data.member_id),
      member_name: new FormControl(data.member_name)
    });
    return form
  }



}
